import React from 'react';
import { useTranslation } from 'react-i18next';
import styled from 'styled-components';
import { LineChart, palette, Typography as T } from '@dev/ee-components';
import { useContactsGrowthData } from '@/services/hooks/useContactsGrowthData';
import useMobile from '@/services/hooks/useMobile';
import { DateRangeSelect } from '../DateRange';
import { MobileDateFilter } from '../MobileDateRange';

import { ContactsGrowthGraphInterface, StyledProps } from '../ContactOverview';

const SectionHeader = styled.div<StyledProps>`
    & > div,
    & > span {
        display: inline-block;
        max-width: 50%;
        ${({ isMobile }): string =>
            isMobile &&
            `
    max-width:100%
    `}
    }
    & > .right {
        float: right;
    }
`;



export const ContactsGrowthGraph = (props: ContactsGrowthGraphInterface): JSX.Element => {
    const { t } = useTranslation();
    const isMobile = useMobile();
    const { formattedData, isGraphLoading, needExpandedYAxis} = useContactsGrowthData(props.contactsGrowthFrom);

    return (
        <div className="board">
            <SectionHeader className="boardsection header" isMobile={false}>
                <T variant="h2">{t('contactsgrowth')}</T>
                <div className="right">
                    {isMobile ? (
                        <MobileDateFilter contactsGrowth={true} setContactsGrowthFrom={props.setContactsGrowthFrom} />
                    ) : (
                        <DateRangeSelect />
                    )}
                </div>
            </SectionHeader>
            <div className="boardsection verticalpadding nohorizontalpadding">
                <LineChart
                    isEmpty={formattedData?.length === 0}
                    data={formattedData}
                    xAxisGroupName="Day"
                    lineConfig={[
                        {
                            dataKey: 'Contacts',
                            color: palette.indigo[6],
                        },
                    ]}
                    height={220}
                    fullWidth={true}
                    showTooltip={true}
                    isLoading={isGraphLoading}
                    showLegend={false}
                    showGrid={true}
                    startFromZero={false}
                    yAllowDecimals={false}
                    xMinTickGap={15}
                    XAxisProps={{
                        interval: 'preserveEnd',
                    }}
                    YAxisProps={{
                        width: needExpandedYAxis ? 85 : 60,
                    }}
                />
            </div>
        </div>
    );
};
